export default __webpack_public_path__ + "static/media/project-main-img.4442ece9.png";